class ComponentBrands extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 16,
      breakpoints: {
        990: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
}

customElements.define('component-brands', ComponentBrands);
